
import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'vue-nprogress'

Vue.use(Router)
Vue.use(NProgress)

const router =  new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'FilterPage',
      component: () => import('./views/FilterPage.vue')
    },
    {
      path: '/FilterPageAge',
      name: 'FilterPageAge',
      component: () => import('./views/FilterPageAge.vue')
    },
    {
      path: '/TableAge',
      name: 'TableAge',
      component: () => import('./views/TableAge.vue')
    },
    {
      path: '/TableTemplate/Area/:id',
      name: 'TableArea',
      component: () => import('./views/TableTemplate2.vue')
    },
    {
      path: '/TableTemplate3/Area/:id',
      name: 'TableArea3',
      component: () => import('./views/TableTemplate3.vue')
    },
    {
      path: '/TableTemplate4/Area/:id',
      name: 'TableArea4',
      component: () => import('./views/TableTemplate4.vue')
    },
    {
      path: '/TableTemplate5/Area/:id',
      name: 'TableArea5',
      component: () => import('./views/TableTemplate5.vue')
    },
  ]
})



export default router